<div id="driver-wizard" class="row ">
     <div class="d-flex justify-content-between align-items-center card-title" id="page-title">
          <h1 *ngIf="!service.justSubscribe" [innerHtml]="'RequestYourRecord' | translator: 'base'">
               Request Your PSP Record
          </h1>
          
          <h1 *ngIf="service.justSubscribe" [innerHtml]="'RecordMonitoring' | translator: 'base'">
               Subscribe to PSP Driver Monitoring
          </h1>
     </div>
     <div class="col-lg-8">
          <div class="card shadow-sm rounded-0 border-0">
               <div class="card-body">
                    <app-complete-bar [step]="1" [totalSteps]="11"></app-complete-bar>
                    <h2 [innerHtml]="'Disclaimers' | translator: 'base'">Disclaimers</h2>
                    <div class="alert alert-danger" role="alert">
                         <h3 class="mb-0" [innerHtml]="'GovernmentWarning' | translator: 'base'">
                              ATTENTION ATTENTION ATTENTION
                         </h3>
                    </div>
                    <p [innerHtml]="'UnauthAccesIllegalTitleText' | translator: 'base'">
                         You are accessing a U.S. Government information system, which includes (1) this computer,
                         (2) this computer network, (3) all computers connected to this network, and (4) all devices and
                         storage media attached to this network or to a computer on this network. This information
                         system is provided for U.S. Government-authorized use only.
                    </p>
                    <p [innerHtml]="'UnauthorizedTitleText' | translator: 'base'">
                         Unauthorized or improper use of this system may result in disciplinary action, as well as civil
                         and criminal penalties.
                    </p>
                    <p [innerHtml]="'ContainsProtectedInfoTitleText' | translator: 'base'">
                         This system contains information protected under the provisions of the Privacy Act of 1974
                         (Public Law 93-579). Any privacy information displayed on the screen or printed shall be
                         protected from unauthorized disclosure. Individuals who violate privacy safeguards may be
                         subject to disciplinary actions, a fine of up to $5,000, or both.
                    </p>
                    <p [innerHtml]="'CertificationBodyTitleText' | translator: 'base'">
                         By using this information system, you understand and consent to the following:
                    </p>
                    <p [innerHtml]="'ReasonableTitleText' | translator: 'base'">
                         You have no reasonable expectation of privacy regarding any communications or data transiting
                         or stored on this information system. At any time, and for any lawful government purpose, the
                         government may monitor, intercept, and search and seize any communication or data transiting or
                         stored on this information system.
                    </p>
                    <p [innerHtml]="'CommunicationsitleText' | translator: 'base'">
                         Any communications or data transiting or stored on this information system may be disclosed or
                         used for any lawful government purpose.
                    </p>
                    <div class="justify-content-md-center form-group form-inline" [formGroup]="form">
                         <label 
                              for="initials" 
                              class="form-label"
                         >
                              <span [innerHtml]="'InitialsRequired' | translator: 'base'">
                                   Requestor's Initials (Required to proceed)
                              </span>
                              <span class="text-danger text-center ms-1" [title]="'Required' | translator: 'base'">*</span>
                         </label>
                         <input 
                              formControlName="initials" 
                              class="bg-light form-control"
                              type="text" 
                              id="driverInitials" 
                              name="driverInitials" 
                              size="3" 
                              required
                              minlength="2"
                              maxlength="3"
                              [title]="'InitialsRequiredTitle' | translator: 'base'" 
                         />
                         <span *ngIf="initials!.invalid && initials!.dirty"
                               class="help-block text-danger">
                              <span [innerHtml]="'FieldRequired' | translator: 'base'"
                                   *ngIf="initials!.errors?.['required']"
                              >
                                   This field is required.
                              </span> 
                              <span [innerHtml]="'InitialsLength' | translator: 'base'"
                                   *ngIf="initials!.errors?.['minlength']"
                              >
                                   Please enter at least 2 characters.
                              </span>
                              <span [innerHtml]="'AlphaOnly' | translator: 'base'"
                                   *ngIf="initials!.errors?.['pattern']" 
                              >
                                   Please use letters only.
                              </span>
                         </span>   
                    </div>

                    <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard">
                         <div class="btn-group" role="group">
                              <button 
                                   [routerLink]="service.continueLinkRoute((service.isReorder() ? 2: 3))"
                                   (click)="scrollToTop()" 
                                   class="btn btn-primary btn-strong" 
                                   [title]="'Continue' | translator: 'base'" 
                                   [disabled]="form.status === 'INVALID'" 
                                   name="driverNext"
                                   id="driverNext"
                              >
                                   <span [innerHtml]="'Continue' | translator: 'base'">Continue</span>
                                   <span class="sr-only" [innerHtml]="'IAgree' | translator: 'base'">I Agree</span>
                              </button>
                         </div>
                    
                         <div class="btn-group" role="group">
                              <button 
                                   *ngIf="service.isReorder() === false"
                                   [routerLink]="service.backLinkRoute(3)" 
                                   (click)="scrollToTop()" 
                                   class="btn btn-outline-primary"
                                   [title]="'Back' | translator: 'base'" 
                                   [innerHtml]="'Back' | translator: 'base'" [title]="'Back' | translator: 'base'"
                                   name="driverBack"
                                   id="driverBack"
                              >
                                   Back
                              </button>
                              <button 
                                   [routerLink]="service.cancelLinkRoute()"
                                   tag="button" 
                                   class="btn btn-light" 
                                   (click)="scrollToTop()"
                                   name="orderCancel" 
                                   id="orderCancel"
                                   [innerHtml]="'Cancel' | translator: 'base'"
                                   [title]="'Cancel' | translator: 'base'"
                              >
                                   Cancel
                              </button>
                         </div>
                    </div>
               </div>
          </div>
     </div>
     <app-progress-wizard 
          *ngIf="wizard"     
          [wizardObj]="wizard"
          [activeStep]="1" 
          pageType="driver"
          class="col-lg-4 sidebar d-none d-lg-block">
     </app-progress-wizard>
</div>